import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  TextField,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
} from "@mui/material";
import { useLocation } from "react-router-dom";

function createData(col1, col2, col3, col4) {
  return { col1, col2, col3, col4 };
}

const rowStyle = {
  backgroundColor: "#DDEEFD",
  px: 1,
  py: 1,
  borderRadius: "10px",
  display: "inline-block",
  fontSize: '13px',
  fontFamily: 'Roboto Flex'
}

const typographyStyle = {
  borderRadius: "10px",
  backgroundColor: "#DDEEFD",
  fontSize: '14px',
  textAlign: 'center',
  alignContent: 'center',
  height: '17px'
}

const menuStyle = {
  '&:hover': {
      backgroundColor: '#D3D3D3',
      color: 'black',
  },
  '&.Mui-selected': {
      backgroundColor: 'grey',
      color: '#fff',
  },
  '&.Mui-selected:hover': {
      backgroundColor: 'grey',
  },

  '&.Mui-focusVisible': {
      backgroundColor: 'grey',
  },
  '&.Mui-selected.Mui-focusVisible': {
      backgroundColor: 'grey',
  },
}

const PregnancyRecommendations = ({ data, handleUpdateData, updateData }) => {
  const [edit, setEdit] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode");
    if (mode) setEdit(mode !== "view");
  }, [location.search]);

  const recommendaionData = data["recommendations"];

  const recommendationTable = createData(
    recommendaionData.session.trimester,
    recommendaionData.session.time,
    recommendaionData.session.frequency
  );

  const typeCPTable = recommendaionData.intensity.map((item) =>
    createData(item.activityType, item.current, item.previous)
  );

  const activitiesTable = recommendaionData.activities.map((item) =>
    createData(item.name, item.current, item.selectedByMother, item.recommended)
  );

  const [currentActivityTable, setCurrentActivityType] =
    useState(activitiesTable);

  // Local editable state seeded from API defaults
  const [timeValue, setTimeValue] = useState(
    updateData?.activityTime ?? recommendaionData.session.time ?? ""
  );
  const [frequencyValue, setFrequencyValue] = useState(
    updateData?.activityFrequency ?? recommendaionData.session.frequency ?? ""
  );

  const handleChange = (name) => {
    setCurrentActivityType((prev) => {
      const updated = prev.map((item) =>
        item.col1 === name ? { ...item, col2: !item.col2 } : item
      );
      handleUpdateData(updated, "table");
      return updated;
    });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography sx={{ pl: 2, fontSize: {xl:'14px', lg:'15px', md:'15px'}, fontWeight: 500, textAlign:'left' }}>
        Recommendations
      </Typography>

      {/* MAIN RESPONSIVE GRID */}
      <Grid container spacing={2} sx={{ px: 1 }}>

        {/* LEFT COLUMN */}
        <Grid size={{xs:12, md:6, lg:6, xl:6}} sx={{ minWidth: 0 }}>
          <Typography sx={{ pl: 1, fontSize: '13px',textAlign:'left' }}>
            For {recommendaionData.name}
          </Typography>

          {/* SUMMARY TABLE */}
          <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
            <Table sx={{ minWidth: 300, background: "transparent", height: 100 }}
              aria-label="simple table">
              <TableHead>
                <TableRow sx={{
                    "& td, & th": {
                      border: 0,
                      py: 1,
                      lineHeight: 0.2,
                      fontSize: "13px",
                    },
                  }}>
                  <TableCell> <Box
                      component="span"
                      sx={{
                        backgroundColor: "#DDEEFD",
                        px: 1,
                        py: 1,
                        borderRadius: "10px",
                        display: "inline-block",
                        fontSize: '13px',
                        fontFamily: 'Roboto Flex'
                      }}
                    >
                        Summary
                    </Box></TableCell>
                  <TableCell>
                  <Box
                      component="span"
                      sx={{
                        backgroundColor: "#DDEEFD",
                        px: 1,
                        py: 1,
                        borderRadius: "10px",
                        display: "inline-block",
                        fontSize: '13px', 
                        fontFamily: 'Roboto Flex'
                      }}
                    >{recommendationTable.col1}
                    </Box></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={{ "& td, & th": { border: 0, py: 0.5, fontSize: "14px" } }}>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>Time</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      disabled={!edit}
                      value={timeValue}
                      onChange={(e) => {
                        setTimeValue(e.target.value);
                        handleUpdateData(e.target.value, "activityTime");
                      }}
                      placeholder="e.g. 30-60 mins / session"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "6px",
                          // backgroundColor: "#f9fcfd",
                          // boxShadow: "0 2px 6px rgba(0,0,0,0.10)",
                          fontSize: "13px",
                          "& fieldset": { border: "1px solid #E5E7EB"},
                        },
                        "& input": { py: 0.5, px: 1, fontSize: "13px" },
                        minWidth: 140,
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "& td, & th": { border: 0, py: 0.5, fontSize: "14px" } }}>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>Frequency</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      disabled={!edit}
                      value={frequencyValue}
                      onChange={(e) => {
                        setFrequencyValue(e.target.value);
                        handleUpdateData(e.target.value, "activityFrequency");
                      }}
                      placeholder="e.g. Min 3 sessions per week"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "6px",
                          // backgroundColor: "#f9fcfd",
                          // boxShadow: "0 2px 6px rgba(0,0,0,0.10)",
                          fontSize: "13px",
                          "& fieldset": { border: "1px solid #E5E7EB" },
                        },
                        "& input": { py: 0.5, px: 1, fontSize: "13px" },
                        minWidth: 140,
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* INTENSITY TABLE */}
          <TableContainer sx={{ mt: 2, overflowX: "auto", maxWidth: "100%" }}>
            <Table size="small">
              <TableHead>
                <TableRow  sx={{
                    "& td, & th": {
                      border: 0,
                      py: 1,
                      lineHeight: 0.2,
                      fontSize: "13px",
                    },
                  }}>
                  <TableCell><Box component={'span'} sx={rowStyle}>Type</Box></TableCell>
                  <TableCell><Box component={'span'} sx={rowStyle}>Current</Box></TableCell>
                  <TableCell><Box component={'span'} sx={rowStyle}>Previous</Box></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {typeCPTable.map((row) => (
                  <TableRow key={row.col1} sx={{
                    "& td, & th": {
                      border: 0,
                      py: 1,
                      lineHeight: 1.2,
                      fontSize: "14px",
                    },
                  }}>
                    <TableCell>{row.col1}</TableCell>
                    <TableCell>
                      <Select
                        size="small"
                        disabled={!edit}
                        value={
                          row.col1 === "Work Related"
                            ? updateData?.workLevel
                            : row.col1 === "Travel Related"
                            ? updateData?.travelLevel
                            : updateData?.leisureLevel
                        }
                        onChange={(e) => handleUpdateData(e, row.col1)}
                        sx={{
                          borderRadius: "50px",
                          backgroundColor: "#f9f9f9",
                          boxShadow: "0 0 0 1px #ddd",
                          height: "18px",
                          width: "85px",
                          fontSize: "14px",
                          fontWeight: 500,
                          my: 1,
                          "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          },
                          "& fieldset": { border: "none" },
                        }}
                      >
                        {row.col2.map((item, i) => (
                          <MenuItem key={i} value={item.intensity} sx={menuStyle}>
                            {item.intensity}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                    <TableCell align="center">{row.col3}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {/* RIGHT COLUMN */}
        <Grid size={{xs:12, md:6, xl:6, lg:6}} sx={{ minWidth: 0 }}>
          <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{
                      "& td, & th": {
                        border: 0,
                        py: 1,
                        lineHeight: 0.2,
                        fontSize: "13px",
                      },
                    }}>
                  <TableCell><Typography sx={{...typographyStyle,width: '67px',}}>Activity</Typography> </TableCell>
                  <TableCell align="center"><Typography sx={{...typographyStyle,width: '55px'}}>Current</Typography></TableCell>
                  <TableCell align="center"><Typography sx={{...typographyStyle,width: '55px'}}>Previous</Typography></TableCell>
                  <TableCell align="center"><Typography sx={{...typographyStyle,width: '55px'}}>Pre.Rec</Typography></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentActivityTable.map((row) => (
                  <TableRow key={row.col1} sx={{
                    "& td, & th": {
                      border: 0,
                      py: 1,
                      lineHeight: 1.2,
                      fontSize: "14px",
                    },
                  }}>
                    <TableCell><Typography sx={{ fontSize: '14px', fontFamily: 'Roboto Flex' }}>{row.col1}</Typography></TableCell>
                    <TableCell align="center">
                      <Checkbox
                        checked={!!row.col2}
                        disabled={!edit}
                        onChange={() => handleChange(row.col1)}
                        size="small"
                        sx={{
                          "& .MuiSvgIcon-root": { fontSize: 17 },
                        }}
                        style={{ padding: 0, margin: 0 }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Checkbox checked={row.col3} size="small"  sx={{
                            "& .MuiSvgIcon-root": { fontSize: 17 },
                          }}
                          style={{ padding: 0, margin: 0 }}/>
                    </TableCell>
                    <TableCell align="center">
                      <Checkbox checked={row.col4} size="small"  sx={{
                            "& .MuiSvgIcon-root": { fontSize: 17 },
                          }}
                          style={{ padding: 0, margin: 0 }}/>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {/* NOTES */}
        <Grid size={{xs:12, xl:6, lg:6, md:6}}>
          <Typography sx={{ fontSize: "14px", fontWeight: 500, textAlign:'left' }}>
            Notes:
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={4}
            disabled={!edit}
            value={updateData?.physicalFitnessNotes}
            onChange={(e) =>
              handleUpdateData(e.target.value, "notes")
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "5px",
                // backgroundColor: "#f9fcfd",
                // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                padding: "8px 12px",
                "& fieldset": {
                  border:"1px solid #E5E7EB",
                },
                fontSize: "14px",
                margin: 1,
              },
            }}
          />
        </Grid>

      </Grid>
    </Box>
  );
};

export default PregnancyRecommendations;
